/**
 * defa.routers.SupportRouter
 * Router for the support functionality
 * @version 1.2.0
 */
const SupportRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'logs/:type/:bid/:page(/)': 'showLog',
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SupportRouter;